import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useState } from 'react';
import s from './index.less';
import Link from '../../components/Link';
import Nothing from "../../components/nothing";
import Pagination from 'rc-pagination';
import pageS from '../list/assets/pagination.less';
import qs from 'qs';
export default function DecorationProcurement (props) {
    useStyles(s);
    useStyles(pageS);
    const pageData = props.pageData || {};
    const [param, setParam] = useState(pageData.params);
    const goPage = (link) => {
        window.open('_self').location = link;
    }
    const pageChange = (page, pageSize) => {
        setParam(Object.assign(param, { page, size: pageSize }))
        if (document) {
            document.body.scrollIntoView({ behavior: 'smooth' })
        }
        getDataList()
    };
    const getDataList = async () => {
        const newParam = { ...param };
        window.location.href = `/elderlyRenovation/list?${qs.stringify(newParam)}`;
    };
    return (
        <div className="page-home">
            <div className='container'>
                <div className="bread-box">
                    <Link to="/" target="_blank">首页</Link><span>&#65125;</span>精商优选
                </div>
                <div className="main-box">
                    <div className='page-title'>精选案例</div>
                    <div className='water-box'>
                            {
                            pageData.list && pageData.list.length ? pageData.list.map((item, index) => {
                            
                                return <div className='list-box' key={index}>
                                        {
                                        item.map((it, ind) => {
                                            return <div className='item-box' key={ind} onClick={() => { goPage(`/generalPage?id=${it.id}&type=4`) }}>
                                                <img src={it.imgUrl ? it.imgUrl : require("../../images/common/detail-default.png")} />
                                                <div>
                                                    {it.title}
                                                </div>
                                            </div>  
                                            })
                                        }
                                </div>
                        })
                            : (<Nothing></Nothing>)
                    }
                    </div>
                </div>
                 {pageData.total ?
                        <div className='pagination-box'>
                            <Pagination prevIcon="上一页" nextIcon="下一页" current={param.page - 0} pageSize={param.size - 0} total={pageData.total - 0} onChange={pageChange} />
                        </div> : null
                    }
            </div>
        </div>
    );
}